import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageLayout from "@/components/feature/PageLayout";
import SEOHead from "@/components/feature/SEOHead";
import HeroSection from "./components/HeroSection";
import HotSection from "./components/HotSection";
import CategoryShowcase from "./components/CategoryShowcase";
import LatestSection from "./components/LatestSection";
import NewsSection from "./components/NewsSection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "苹果视频",
    url: "https://www.apple-video.com",
    description: "苹果视频提供免费高清电影电视剧，流畅播放不卡顿，汇聚香蕉视频、红桃视频、91视频、蜜桃视频等热门资源，全集免费在线观看。",
    sameAs: [
      "https://weibo.com/applevideo",
    ],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "400-888-0000",
      contactType: "customer service",
    },
  };

  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "苹果视频",
    url: "https://www.apple-video.com",
  };

  const webpageJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "苹果视频 - 免费高清电影电视剧流畅播放",
    description: "苹果视频提供免费高清电影电视剧，流畅播放不卡顿，汇聚香蕉视频、红桃视频、91视频、蜜桃视频等热门资源，全集免费在线观看。",
    url: "https://www.apple-video.com",
  };

  return (
    <PageLayout
      seo={
        <SEOHead
          title="苹果视频 - 免费高清电影电视剧流畅播放不缓冲"
          description="苹果视频提供免费高清电影电视剧，流畅播放不卡顿，汇聚香蕉视频、红桃视频、91视频、蜜桃视频等热门资源，全集免费在线观看。"
          keywords="苹果视频,高清,流畅,不缓冲,免费在线观看,香蕉视频,红桃视频,91视频,蜜桃视频,电影,电视剧,全集"
        />
      }
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageJsonLd) }}
      />

      <Navbar />
      <HeroSection />
      <HotSection />
      <CategoryShowcase />
      <LatestSection />
      <NewsSection />
      <FAQSection />
      <Footer />
    </PageLayout>
  );
}